// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__17m8z","inner":"Form_inner__3TSq2","range":"Form_range__1Kfwa","name":"Form_name__vUDE5","actions":"Form_actions__1FXUa"};